// LocalStorage helpers for streak, trackers, journal, and premium toggle.
const KEY = {
  streak: "maaya_streak",
  lastDone: "maaya_last_done",
  trackers: "maaya_trackers",
  journal: "maaya_journal",
  premium: "maaya_premium",
  selectedReset: "maaya_selected_reset",
};

function todayStr() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function yesterdayStr() {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function getStreak() {
  const s = parseInt(localStorage.getItem(KEY.streak) || "0", 10);
  const last = localStorage.getItem(KEY.lastDone);
  // If the last done is older than yesterday, streak is broken.
  if (last && last !== todayStr() && last !== yesterdayStr()) {
    return 0;
  }
  return isNaN(s) ? 0 : s;
}

export function getLastDone() {
  return localStorage.getItem(KEY.lastDone);
}

export function isDoneToday() {
  return localStorage.getItem(KEY.lastDone) === todayStr();
}

export function markDone() {
  const today = todayStr();
  const last = localStorage.getItem(KEY.lastDone);
  if (last === today) return getStreak();
  let streak = parseInt(localStorage.getItem(KEY.streak) || "0", 10);
  if (isNaN(streak)) streak = 0;
  if (last === yesterdayStr()) {
    streak += 1;
  } else {
    streak = 1;
  }
  localStorage.setItem(KEY.streak, String(streak));
  localStorage.setItem(KEY.lastDone, today);
  return streak;
}

export function getTrackers() {
  const today = todayStr();
  try {
    const raw = JSON.parse(localStorage.getItem(KEY.trackers) || "{}");
    return raw[today] || { mood: null, energy: null, sleep: "", hydration: 0 };
  } catch {
    return { mood: null, energy: null, sleep: "", hydration: 0 };
  }
}

export function saveTrackers(values) {
  const today = todayStr();
  let raw = {};
  try {
    raw = JSON.parse(localStorage.getItem(KEY.trackers) || "{}");
  } catch {
    raw = {};
  }
  raw[today] = { ...(raw[today] || {}), ...values };
  localStorage.setItem(KEY.trackers, JSON.stringify(raw));
  return raw[today];
}

export function getAllTrackers() {
  try {
    return JSON.parse(localStorage.getItem(KEY.trackers) || "{}");
  } catch {
    return {};
  }
}

export function getJournal() {
  try {
    return JSON.parse(localStorage.getItem(KEY.journal) || "[]");
  } catch {
    return [];
  }
}

export function saveJournalEntry(entry) {
  const list = getJournal();
  const today = todayStr();
  const next = [{ ...entry, date: today, savedAt: new Date().toISOString() }, ...list].slice(0, 200);
  localStorage.setItem(KEY.journal, JSON.stringify(next));
  return next;
}

export function isProUser() {
  return localStorage.getItem(KEY.premium) === "true";
}

export function toggleProUser() {
  const current = isProUser();
  localStorage.setItem(KEY.premium, String(!current));
  return !current;
}

// Selected reset (Pro only — lets a Pro user pick a reset from the library).
export function getSelectedResetId() {
  const raw = localStorage.getItem(KEY.selectedReset);
  if (!raw) return null;
  try {
    const { id, date } = JSON.parse(raw);
    // Selection only valid for the same calendar day.
    if (date !== todayStr()) return null;
    return id;
  } catch {
    return null;
  }
}

export function setSelectedResetId(id) {
  localStorage.setItem(KEY.selectedReset, JSON.stringify({ id, date: todayStr() }));
}

export function clearSelectedResetId() {
  localStorage.removeItem(KEY.selectedReset);
}

export { todayStr };
